import {
  Card,
  CardDescription,
  CardTitle,
} from "@/components/ui/card";

export default function CardBasic({
  cardTitle,
  cardDescription,
}: {
  cardTitle: string;
  cardDescription: string;
}) {
  return (
    <Card
      className="mx-4 text-custom-darkblue 
        w-32 h-32 
        sm:w-40 sm:h-36 
        md:w-48 md:h-40 
        lg:w-52 lg:h-44 
        xl:w-56 xl:h-46 
        2xl:w-64 2xl:h-50 
        bg-gray-eee hover:bg-custom-secolor 
        group hover:text-white 
        rounded-xl shadow-xl 
        hover:scale-105 
        transition-all duration-300 ease-in-out transform-gpu 
        flex flex-col items-center justify-center"
    >
      <CardTitle className="animate-bounce text-lg sm:text-xl md:text-2xl mb-2 group-hover:text-white">
        {cardTitle}
      </CardTitle>
      <CardDescription className="text-xs sm:text-sm md:text-base text-custom-darkblue group-hover:text-white text-center px-2">
        {cardDescription}
      </CardDescription>
    </Card>
  );
}
